/* 🤖 this file was generated by svg-to-ts */
export const matIconNightlight: {
  name: 'nightlight';
  data: string;
} = {
  name: 'nightlight',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 4c.34 0 .68.02 1.01.07C13.1 6.23 12 9.05 12 12s1.1 5.77 3.01 7.93c-.33.05-.67.07-1.01.07-4.41 0-8-3.59-8-8s3.59-8 8-8m0-2C8.48 2 4 6.48 4 12s4.48 10 10 10c1.82 0 3.53-.5 5-1.35-2.99-1.73-5-4.95-5-8.65s2.01-6.92 5-8.65A9.973 9.973 0 0 0 14 2z"/></svg>`
};
